import React, { VoidFunctionComponent } from "react";
import { DetailsItem } from "@/components/responsive/product/warranties/detailsItem/DetailsItem";
import { BottomLayout } from "@/components/responsive/product/layer/bottomLayout/BottomLayout";
import { Button } from "@/components/responsive/commun/button";
import { ExtendedWarranty } from "@/models/scope/productSheet/ExtendedWarranty";
import Utils from "@/libs/Utils";

interface Props {
  extendedWarranties: ExtendedWarranty[];
  setWarrantySelected: (status: boolean) => void;
  onClose: () => void;
}

export const WarrantiesLayer: VoidFunctionComponent<Props> = ({ extendedWarranties, setWarrantySelected, onClose }) => {
  if (!extendedWarranties?.length) return null;

  const { popinDescription, metaInfos, cost, popinSubTitle } = extendedWarranties[0] || {};

  const handleAddWarranty = () => {
    setWarrantySelected(true);
    onClose();
  }

  return (
    <div className="warranty">
      <p className="layer-warranty-price">{`${Utils.formatPriceWithoutTax(cost)} €`}</p>
      <p className="layer-warranty-description">
        {popinSubTitle}
      </p>
      <div className="layer-warranty-details">
        {popinDescription?.map((detail: string, i: number) => (
          <DetailsItem detail={detail} key={i} index={i} />
        ))}
      </div>
      <a
        className="layer-warranty-legal"
        href={Utils.getMetaInfosValueByCode("saleConditionsLink", metaInfos) || ""}
        target="_blank"
        rel="noopener noreferrer"
      >
        Voir conditions générales
      </a>
      <BottomLayout>
        <div className='bottom-button'>
          <Button type='adaptive' callBack={handleAddWarranty}>
            <p className='uppercase'>Ajouter au panier</p>
          </Button>
        </div>
      </BottomLayout>
    </div>
  );
};